module.exports = __webpack_public_path__ + "static/media/bus.5929a792.svg";